module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as4403-a6be0b93f681c2548c12f401b3da38e0.jpg";